export function rollingDangerScore(pressPositions: number[]): number {
  const recent = pressPositions.slice(-10);
  if (recent.length === 0) return 0;
  if (recent.some((position) => !Number.isInteger(position) || position < 1 || position > 99)) {
    throw new RangeError("Safe button positions must be integers from 1 to 99.");
  }
  const observedTotal = recent.reduce((total, position) => total + position, 0);
  return Math.floor((observedTotal + (10 - recent.length)) / 10);
}

export function formatDangerScore(value: number): string {
  return `${Math.max(0, Math.min(99, Math.floor(value)))}/99`;
}

export function formatCountdown(milliseconds: number): string {
  const tenths = Math.ceil(Math.max(0, milliseconds) / 100) / 10;
  return tenths.toFixed(1);
}

export function formatCompact(value: number): string {
  return new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(value);
}

export function waveIndex(buttonIndex: number): number {
  const row = Math.floor(buttonIndex / 10);
  const column = buttonIndex % 10;
  return row + column;
}

export function hasVersionGap(currentVersion: number, incomingVersion: number): boolean {
  return incomingVersion > currentVersion + 1;
}

export function dailyShareText(score: number, url: string): string {
  const chance = Math.max(1, 100 - score);
  const result = score === 99
    ? "I found all 99 wrong buttons—a perfect Daily Challenge."
    : `I pressed ${score} wrong button${score === 1 ? "" : "s"} before I was right.`;
  return `${result} Only a ${chance}% chance of getting that far. ${url}`;
}

export function multiplayerShareText(streak: number, danger: number, remaining: number, url: string): string {
  return `My ${streak}-button wrong streak reached ${formatDangerScore(danger)} danger before I hit the 1-in-${remaining} right button. ${url}`;
}
